import React, { useState, useEffect } from "react";
import * as S from "./Nav.styles";
// import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Nav = () => {
  const [active, setActive] = useState(false);
  const [navLogo, setNavLogo] = useState();

  const getLogo = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/v1/admin/logo`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await res.json();

    setNavLogo(data);
  };
  useEffect(() => {
    getLogo();
  }, []);

  const adminLinks = [
    {
      id: 1,
      url: "/account",
      title: "Home",
    },
    {
      id: 2,
      url: "/account/clinics",
      title: "Clinics",
    },
    {
      id: 3,
      url: "/account/news?page=1",
      title: "News",
    },
    {
      id: 4,
      url: "/account/geninfo",
      title: "General",
    },
    {
      id: 5,
      url: "/account/email",
      title: "Email",
    },
  ];

  const toggleClass = () => {
    setActive(!active);
  };

  const navigate = useNavigate();
  const adminlink = localStorage.getItem("tokenadmin") ? adminLinks : null;
  // const adminlinkHom = localStorage.getItem("token") ? adminLinksHom : null;
  return (
    <S.Nav
      className="navbar is-transparent has-background-grey-dark is-fixed-top is-spaced"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="navbar-wrapper">
        <div className="navbar-content">
          <div className="navbar-item ">
            <figure className="image">
              <img
                src={navLogo && navLogo[0] && navLogo[0].filePath}
                alt={navLogo && navLogo[0] && navLogo[0].fileName}
              />
            </figure>
          </div>
          <div className="navbar-menu notburger-menu">
            <div className="navbar-start">
              {adminlink &&
                adminlink.map((link) => (
                  <Link
                    to={link.url}
                    key={link.id}
                    className="navbar-item has-text-white"
                    // onClick={() => {
                    //   toggleClassLkf();
                    // }}
                  >
                    {link.title}
                  </Link>
                ))}
            </div>
            <div className="navbar-end">
              {localStorage.getItem("tokenadmin") ? (
                <button
                  className="button is-link"
                  onClick={() => {
                    localStorage.removeItem("tokenadmin");
                    navigate("/");
                    toggleClass();
                  }}
                >
                  Logout
                </button>
              ) : null}
            </div>
          </div>
          <div
            role="button"
            aria-label="menu"
            aria-expanded="false"
            className={`navbar-burger ${
              active ? "is-active" : ""
            } js-burger has-background-white`}
            onClick={() => {
              toggleClass();
            }}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        {localStorage.getItem("tokenadmin") ? (
          <div className="burger-menu">
            <div className={`navbar-menu ${active ? "is-active" : ""}`}>
              <div className="navbar-start">
                <div className="navbar-dropdown is-boxed">
                  <div className={`navbar-dropdown is-boxed`}>
                    {adminlink.map((link) => (
                      <Link
                        to={link.url}
                        key={link.id}
                        className="navbar-item"
                        onClick={() => {
                          toggleClass();
                        }}
                      >
                        {link.title}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              {localStorage.getItem("tokenadmin") ? (
                <div className="navbar-end">
                  <div className="navbar-item">
                    <button
                      className="button is-link"
                      onClick={() => {
                        localStorage.removeItem("tokenadmin");
                        navigate("/admin");
                        toggleClass();
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </S.Nav>
  );
};

// Nav.propTypes = {
//   links: PropTypes.arrayOf(
//     PropTypes.shape({
//       url: PropTypes.string.isRequired,
//       title: PropTypes.string.isRequired,
//       active: PropTypes.func,
//     })
//   ),
// };

export default Nav;
